webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fuse_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VueFuse',
  data: function data() {
    return {
      fuse: null,
      value: '',
      result: []
    };
  },

  props: {
    placeholder: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    eventName: {
      type: String,
      default: 'fuseResultsUpdated'
    },
    inputChangeEventName: {
      type: String,
      default: 'fuseInputChanged'
    },
    defaultAll: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    includeScore: {
      type: Boolean,
      default: false
    },
    includeMatches: {
      type: Boolean,
      default: false
    },
    tokenize: {
      type: Boolean,
      default: false
    },
    matchAllTokens: {
      type: Boolean,
      default: false
    },
    findAllMatches: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    shouldSort: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.6
    },
    location: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 100
    },
    maxPatternLength: {
      type: Number,
      default: 32
    },
    minMatchCharLength: {
      type: Number,
      default: 1
    },
    keys: {
      type: Array
    }
  },
  computed: {
    options: function options() {
      var options = {
        caseSensitive: this.caseSensitive,
        includeScore: this.includeScore,
        includeMatches: this.includeMatches,
        tokenize: this.tokenize,
        matchAllTokens: this.matchAllTokens,
        findAllMatches: this.findAllMatches,
        shouldSort: this.shouldSort,
        threshold: this.threshold,
        location: this.location,
        distance: this.distance,
        maxPatternLength: this.maxPatternLength,
        minMatchCharLength: this.minMatchCharLength,
        keys: this.keys
      };
      if (this.id !== '') {
        options.id = this.id;
      }
      return options;
    }
  },
  watch: {
    list: function list() {
      this.fuse.list = this.list;
      this.fuseSearch();
    },
    search: function search() {
      this.value = this.search;
    },
    value: function value() {
      this.$parent.$emit(this.inputChangeEventName, this.value);
      this.fuseSearch();
    },
    result: function result() {
      this.$parent.$emit(this.eventName, this.result);
    }
  },
  methods: {
    initFuse: function initFuse() {
      this.fuse = new __WEBPACK_IMPORTED_MODULE_0_fuse_js___default.a(this.list, this.options);
      if (this.defaultAll) {
        this.result = this.list;
      }
      if (this.search) {
        this.value = this.search;
      }
    },
    fuseSearch: function fuseSearch() {
      if (this.value.trim() === '') {
        if (this.defaultAll) {
          this.result = this.list;
        } else {
          this.result = [];
        }
      } else this.result = this.fuse.search(this.value.trim());
    }
  },
  ready: function ready() {
    this.initFuse();
  },
  mounted: function mounted() {
    this.initFuse();
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      term: '',
      termtwo: '',
      defaultAllToggle: false,
      options: {
        keys: ["brand", "model.name", "model.id"]
      },
      componentResults: [],
      methodResults: [],
      keys: ["brand", "model.name", "model.id"],
      bikes: [{
        brand: "Schwinn",
        model: {
          name: "Classic",
          id: "1345ppppgd"
        }
      }, {
        brand: "Red Line",
        model: {
          name: "Flight",
          id: "5430sdfsdf"
        }
      }, {
        brand: "Hoffman",
        model: {
          name: "Condore",
          id: "0543ADS"
        }
      }, {
        brand: "Tribe",
        model: {
          name: "CRMO",
          id: "043dfgdfg2"
        }
      }, {
        brand: "Mongoose",
        model: {
          name: "isLoose",
          id: "50ff00"
        }
      }, {
        brand: "GT",
        model: {
          name: "Dyno",
          id: "234fff5"
        }
      }, {
        brand: "Canonndale",
        model: {
          name: "3500",
          id: "cd3asd5"
        }
      }, {
        brand: "Giant",
        model: {
          name: "pegasus",
          id: "6346"
        }
      }]
    };
  },

  methods: {
    toggle: function toggle() {
      this.defaultAllToggle = !this.defaultAllToggle;
      this.$forceUpdate();
    }
  },
  watch: {
    term: function term() {
      var _this = this;

      this.$search(this.term, this.bikes, this.options).then(function (results) {
        _this.methodResults = results;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$on('bikesChanged', function (results) {
      _this2.componentResults = results;
    });
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fuse__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_fuse__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "demo"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("This pluggin provides the 'vue-fuse' component, which can be dropped into your app. The component UI is a barebones <input> tag, as shown below.")]), _c('p', [_vm._v(" The component also takes a number of props, that are used to configure the search and define the event that is eminated when the search results update.")]), _vm._v(" "), _c('vue-fuse', {
    attrs: {
      "placeholder": "Search for bikes",
      "keys": _vm.keys,
      "list": _vm.bikes,
      "event-name": "bikesChanged",
      "inputChangeEventName": "bikeSearchInputChanged",
      "default-all": _vm.defaultAllToggle,
      "search": _vm.termtwo
    }
  }), _vm._v(" "), _c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.toggle
    }
  }), _vm._v("defaultAll")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" you can bind to the :search prop as well, so that you can map your own data source to the component. (try typing in the input here -->)\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termtwo),
      expression: "termtwo"
    }],
    domProps: {
      "value": (_vm.termtwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.termtwo = $event.target.value
      }
    }
  })]), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.componentResults), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "demo"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Instead of using the component, you can use the $search instance method to execute a search programatically")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.methodResults), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "demo"
  }, [_c('h2', [_vm._v("here's a list of bikes to search through!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.bikes), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('code', [_vm._v("vue-fuse")]), _vm._v(" component demo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('code', [_vm._v("$search")]), _vm._v(" instance method demo")])
}]}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.72db27b8a9ab3b89897e.js